import styled from 'styled-components'

export const HintWrapper = styled.div<{ $placeholder: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  column-gap: 16px;
  row-gap: 8px;
  font-size: 12px;
  ${({ $placeholder }) => $placeholder && 'visibility: hidden;'}
`

export const HintContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`
